import { computed, inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { FeatureSpecFacade } from '@core/feature-spec-logic';
import { FeatureCode } from '@core/feature-spec-types';
import {
  DefaultRatingScaleSelectors,
  RatingScalesSelectors,
  UnbiasedHiringSettingsSelectors,
} from '@recruitee/candidate-evaluation-settings-data';

@Injectable({ providedIn: 'root' })
export class CandidateEvaluationSettingsDataService {
  private readonly store = inject(Store);
  private readonly featureSpecFacade = inject(FeatureSpecFacade);

  public readonly unbiasedHiringSettings = this.store.selectSignal(
    UnbiasedHiringSettingsSelectors.data,
  );
  public readonly unbiasedHiringSettingsLoaded = this.store.selectSignal(
    UnbiasedHiringSettingsSelectors.isLoaded,
  );

  public readonly defaultRatingScale = this.store.selectSignal(DefaultRatingScaleSelectors.data);
  public readonly defaultRatingScaleLoaded = this.store.selectSignal(
    DefaultRatingScaleSelectors.isLoaded,
  );

  public readonly defaultScaleOptions = this.store.selectSignal(
    RatingScalesSelectors.defaultScaleOptions,
  );
  public readonly ratingScalesLoaded = this.store.selectSignal(RatingScalesSelectors.isLoaded());

  public readonly hasCandidateAnonymizationEntitled = this.featureSpecFacade.selectIsEntitled(
    FeatureCode.CandidateAnonymization,
  );
  public readonly hasFairEvaluationsEntitled = this.featureSpecFacade.selectIsEntitled(
    FeatureCode.FairEvaluations,
  );

  public readonly hasAnyUnbiasedHiringFeatureEntitled = computed(
    () => this.hasCandidateAnonymizationEntitled() || this.hasFairEvaluationsEntitled(),
  );

  public readonly fairEvaluationSettings = computed(
    () => this.unbiasedHiringSettings()?.fairEvaluations || null,
  );
  public readonly candidateAnonymizationSettings = computed(
    () => this.unbiasedHiringSettings()?.anonymousCandidates || null,
  );
}
